var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1464",
    clipPath: "url(#clip0_3524_137997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 135",
    d: "M145.466 38.7803C147.425 34.2121 152.812 31.8757 157.307 33.9514C181.61 45.174 200.824 64.4298 211.354 88.3816C223.057 114.998 223.078 145.233 211.413 172.435C199.748 199.637 177.353 221.578 149.154 233.431C123.778 244.098 95.5725 245.809 69.6188 238.437C64.8186 237.074 62.6357 231.936 64.5947 227.368L105.03 133.074L145.466 38.7803Z",
    fill: "url(#paint0_linear_3524_137997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M72.6686 239.233L101.497 214.834L74.4839 204.377C72.2328 209.581 66.95 221.656 64.0453 228.685C62.4768 235.947 68.693 238.87 72.6686 239.233Z",
    fill: "#5C76B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 136",
    d: "M104.534 211.22C102.575 215.788 97.1875 218.124 92.6927 216.049C68.3904 204.826 49.1764 185.57 38.6456 161.618C26.9433 135.002 26.9223 104.767 38.5872 77.5653C50.2521 50.3633 72.6473 28.4223 100.846 16.5691C126.222 5.90247 154.427 4.19128 180.381 11.5629C185.181 12.9263 187.364 18.0637 185.405 22.632L144.97 116.926L104.534 211.22Z",
    fill: "url(#paint1_linear_3524_137997)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3524_137997",
    x1: 217.885,
    y1: 122.694,
    x2: 53.6372,
    y2: 196.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A276DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B92E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3524_137997",
    x1: 32.1145,
    y1: 127.306,
    x2: 196.363,
    y2: 53.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD99EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8C6F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3524_137997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioIcon);
export default __webpack_public_path__ + "static/media/studio_icon.5ee3f0f4e41097ff53a4c3c70fcdea16.svg";
export { ForwardRef as ReactComponent };